module.exports = __webpack_public_path__ + "17d46e6b9be78b01293d815690504f81.png";